<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- begin ---->

    <v-card class="box">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong>Visitor Reports </strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row dense justify="center">
        <v-checkbox v-for="(vt, index) in vt_list" :key="index" v-model="sel_vt" :label="vt" :value="vt"></v-checkbox>
      </v-row>
      <!-- {{ sel_vt }}||{{ transaction }} -->
      <v-row fluid justify="center">
        <v-radio-group v-model="transaction" row>
          <v-radio label="All" value="All"></v-radio>
          <v-radio label="Not Checked-out" value="NotCheckedOut"></v-radio>
        </v-radio-group>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="2" md="2"></v-col>

        <v-col cols="12" sm="4" md="4">
          <v-datetime-picker dateFormat="dd-MM-yyyy" timeFormat="hh:mm aa" label="From Date"
            v-model="from_date_time"></v-datetime-picker>
        </v-col>

        <v-col cols="12" sm="4" md="4">
          <v-datetime-picker dateFormat="dd-MM-yyyy" timeFormat="hh:mm aa" label="To Date"
            v-model="to_date_time"></v-datetime-picker>
        </v-col>
      </v-row>
      <v-row dense justify="center">
        <v-btn class="button" @click="fetch">Fetch Report</v-btn>
      </v-row>

      <!-- {{ visitor_visit_data_list }} -->
    </v-card>

    <!-- table view -->
    <v-card class="box" v-if="visitor_visit_data_list != null">
      <!-- excel export btn code -->
      <v-row dense>
        <v-col cols="12" sm="2" md="2" v-if="visitor_visit_data_list.length != 0">
          <!-- <v-btn color="success" outlined rounded>
            <download-excel
              class="mr-2 pb-3 pt-2"
              :data="visitor_visit_data_list"
              :fields="table_fields"
              worksheet="VisitorList"
              name="VisitorReport.xls"
            >
              <v-icon dark>mdi-file-excel</v-icon> Export
            </download-excel>
          </v-btn> -->
          <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'VisitorReports')"
            :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
        </v-col>
        <v-col cols="12" sm="1" md="1" align="left">
          <!-- <v-btn class="button" @click="generatePDF()">GET PDF </v-btn> -->
        </v-col>
        <v-col cols="12" sm="4" md="4"></v-col>
        <v-col cols="12" sm="4" md="4">
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-col>
      </v-row>
      <!-- excel export btn code end -->
      <div id="my-table-id">
        <v-data-table :headers="headers" :items="visitor_visit_data_list" :search="search" class="mytable1"
          ref="myTable">
          <!-- <v-data-table :headers="headers"> -->
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Visitor Report</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>

          <!-- photo icon -->
          <template v-slot:[`item.photo`]="{ item }">
            <div v-if="item.photo_file_path !== null">
              <v-avatar size="25" class="edit-avatar">
                <v-icon class="mr-2 edit-v-icon" @click="
                  viewPhoto(item);
                  dialog_add_new = true;
                " title="Photo">mdi-eye</v-icon>
              </v-avatar>
            </div>
          </template>
          <!-- approve and reject -->
          <template v-slot:[`item.approved`]="{ item }">
            <div v-if="item.isapproved == 'Yes'">
              <v-avatar size="25" class="edit-avatar">
                <v-icon class="mr-2 edit-v-icon" color="green" title="Approved">mdi-check-bold</v-icon>
              </v-avatar>
            </div>
          </template>
          <template v-slot:[`item.rejected`]="{ item }">
            <div v-if="item.isrejected == 'Yes'">
              <v-avatar size="25" class="edit-avatar">
                <v-icon class="mr-2 edit-v-icon" color="red" title="Rejected">mdi-check-bold</v-icon>
              </v-avatar>
            </div>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <!-- dialog box for photo -->
    <v-dialog v-model="dialog_add_new" transition="dialog-top-transition" max-width="700px" max-height="800px">
      <v-card class="box">
        <v-toolbar class="toolbar" flat dense>
          <v-btn icon dark @click="dialog_add_new = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Visitor Name:&nbsp;{{ d_visitor_name }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <center>
          <v-img style="width: 280px; height: 350px; margin: 3px" contain
            :src="awspath + d_photo_file_path + d_photo_file_name" v-if="d_photo_file_path !== null"></v-img>
        </center>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import VueHtml2pdf from "vue-html2pdf";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";
export default {
 
  components: {
    VueHtml2pdf,
    Breadcrumbs
  },
  data: () => ({
    snackbar_msg: "",
    // extraBreadcrumbItems: [
   

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    color: "",
    snackbar: false,
    overlay: false,
    ///////////////////////////////////////////////
    vt_list: null,
    sel_vt: [],
    transaction: null,
    from_date_time: null,
    // from_date_time: new Date().toLocaleString(),
    to_date_time: null,
    ////////////////////////////////////////
    visitor_visit_data_list: null,
    search: "",
    dialog_add_new: false,
    d_photo_file_path: null,
    d_photo_file_name: null,
    d_visitor_name: null,
    awspath: null,
    headers: [
      { text: "Sr. No", value: "srno" },
      {
        text: "Reg No / Emp Code / User ID",
        value: "user_name",
      },

      { text: "Mobile No", value: "visitor_data.visitor_mobile" },
      { text: "Visitor Name", value: "visitor_data.visitor_name" },
      { text: "Photo", value: "photo" },
      { text: "Purpose", value: "purpose" },
      { text: "Check-IN Date and Time", value: "checkintime" },
      { text: "Check-Out Date and Time", value: "checkouttime" },
      // { text: "Visit Type", value: "visittype" },
      { text: "Whom To Contact", value: "vv_whom_to" },
      { text: "IsApprove", value: "approved" },
      { text: "IsRejected", value: "rejected" },
      { text: "Approved/Rejected By", value: "approvalby" },
      { text: "Visitor Address", value: "visitor_data.visitor_address" },
    ],
    table_fields: {
      "Sr. No": "srno",
      "Reg No / Emp Code / User ID": "user_name",
      "Mobile No": "visitor_data.visitor_mobile",
      "Visitor Name": "visitor_data.visitor_name",
      Purpose: "purpose",
      "Check-IN Date and Time": "checkintime",
      "Check-Out Date and Time": "checkouttime",
      "Whom To Contact ": "vv_whom_to",
      "Visit Type": "visittype",
      "Visitor Address": "visitor_data.visitor_address",
      Approve: "isapproved",
      Rejected: "isrejected",
    },
  }),
  mounted() {
    this.onload();
    // this.date_function();
  },
  created() {
    this.awspath = localStorage.getItem("awspath");
  },
  methods: {
       fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
            },
    
    // current date and time code
    date_function: function () {
      var currentDate = new Date();

      console.log("current date", currentDate);

      var formatted_date = new Date().toJSON().slice(0, 10).replace(/-/g, "/");

      console.log("format date", formatted_date);
    },
    // code end
    onProgress(event) {
      console.log(`Processed: ${event} / 100`);
    },
    generatePDF() {
      this.$refs.html2Pdf.generatePdf();
    },

    viewPhoto(item) {
      console.log("add people", item);
      this.d_photo_file_path = item.photo_file_path;
      this.d_photo_file_name = item.photo_file_name;
      this.d_visitor_name = item.visitor_data.visitor_name;
      console.log(this.d_photo_file_path);
      console.log(this.d_photo_file_name);
      console.log(this.d_visitor_name);
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    formatDate(a, withTime) {
      return withTime
        ? `${a.getFullYear()}-${
            a.getMonth() + 1
          }-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`
        : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`;
    },
    ///////////
    onload() {
      this.overlay = true;
      axios
        .post("/visitorManagement/initReport")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.vt_list = res.data.vt_list;
            this.showSnackbar("green", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    }, //end
    /////////////////////////
    fetch() {
      this.visitor_visit_data_list = null;
      let form_from_date_time = this.formatDate(this.from_date_time, true);
      let form_to_date_time = this.formatDate(this.to_date_time, true);
      const formdata = {
        sel_vt: this.sel_vt,
        transaction: this.transaction,
        from_date_time: form_from_date_time,
        to_date_time: form_to_date_time,
      };
      this.overlay = true;
      axios
        .post("/visitorManagement/visitReport", formdata)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.visitor_visit_data_list = res.data.visitor_visit_data_list;
            this.showSnackbar("green", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    }, //end
  },
};
</script>

<style scoped>
.button {
  margin: 0px !important;
}
</style>